<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $tc('messages.schools', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.store" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $tc('messages.schools', 1) }}
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.name')" for="name" />
                            <FormInput
                                required
                                id="school_name"
                                v-model.trim="form.name"
                                name="name"
                                type="text"
                                max="60"
                                class="mt-1 w-full"
                            />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.school_code')" for="school_code" />
                            <FormInput
                                id="school_school_code"
                                v-model.trim="form.school_code"
                                name="school_code"
                                type="text"
                                max="60"
                                class="mt-1 w-full"
                            />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$tc('messages.languages', 1)" for="language" />
                            <FormSelect
                                id="language"
                                v-model="form.locale"
                                :options="options.languages"
                                optgroups
                                class="mt-1 w-full"
                            />
                        </div>
                    </div>

                    <div class="sm:col-span-12">
                        <div class="mt-1">
                            <label v-for="stage in options.stages" class="mr-1" :key="stage.value">
                                <input
                                    v-model="form.stage_ids"
                                    name="stages"
                                    :value="stage.value"
                                    type="checkbox"
                                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                />
                                {{ stage.text }}
                            </label>
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $tc('messages.sections', 2) }}
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-12">
                        <div class="mt-1">
                            <label v-for="section in options.sections" class="mr-1" :key="section.value">
                                <BadgePill :color="form.sections.includes(section.value) ? 'indigo' : 'gray'">
                                    <div class="flex gap-1 p-1">
                                        <input
                                            v-model="form.sections"
                                            name="sections"
                                            :value="section.value"
                                            type="checkbox"
                                            class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                        />
                                        <span>{{ section.text }} </span>
                                    </div>
                                </BadgePill>
                            </label>
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import CentralLayout from '@/Shared/CentralLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import BadgePill from '@/components/BadgePill.vue';

export default {
    components: {
        BadgePill,
        SubmitFormButton,
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormSelect,
    },
    layout: CentralLayout,
    name: 'Edit',
    props: ['meta', 'options', 'school'],
    data() {
        return {
            form: this.$inertia.form({
                name: this.school.name,
                school_code: this.school.school_code,
                locale: this.school.locale,
                stage_ids: this.school.stage_ids,
                sections: this.school.sections,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
